import { create } from 'zustand';

export interface Document {
  id: number;
  name: string;
  type: string;
  size: string;
  uploadDate: string;
  projectId?: number;
  milestoneId?: number;
}

interface DocumentStore {
  documents: Document[];
  addDocument: (document: Omit<Document, 'id'>) => void;
  removeDocument: (id: number) => void;
  getProjectDocuments: (projectId: number) => Document[];
}

export const useDocumentStore = create<DocumentStore>((set, get) => ({
  documents: [],
  addDocument: (document) => set((state) => ({
    documents: [...state.documents, { ...document, id: state.documents.length + 1 }]
  })),
  removeDocument: (id) => set((state) => ({
    documents: state.documents.filter(doc => doc.id !== id)
  })),
  getProjectDocuments: (projectId) => get().documents.filter(doc => doc.projectId === projectId)
}));